var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.876 12.1239C4.467 13.0926 5.3205 13.874 6.33752 14.3773C7.35454 14.8806 8.4934 15.0853 9.62204 14.9676C10.7507 14.85 11.8228 14.4148 12.7142 13.7125C13.6055 13.0103 14.2795 12.0697 14.658 10.9999H16.748C16.3645 12.4823 15.5638 13.8235 14.441 14.8644C13.3181 15.9054 11.9202 16.6023 10.4131 16.8727C8.90605 17.143 7.35305 16.9754 5.9384 16.3896C4.52374 15.8038 3.30682 14.8246 2.432 13.5679L0 15.9999V9.99994H6L3.876 12.1239ZM14.125 5.87494C13.5337 4.90611 12.6799 4.12472 11.6626 3.6214C10.6452 3.11807 9.50609 2.91342 8.37719 3.03118C7.24829 3.14894 6.17589 3.58428 5.28434 4.28672C4.3928 4.98916 3.71863 5.92993 3.34 6.99994H1.25C1.63336 5.51705 2.4341 4.17526 3.55719 3.13381C4.68028 2.09237 6.07858 1.39498 7.58614 1.12442C9.09371 0.853862 10.6472 1.02148 12.0624 1.60739C13.4775 2.1933 14.6949 3.1729 15.57 4.42994L18 1.99994V7.99994H12L14.125 5.87494Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLoading);
export default __webpack_public_path__ + "static/media/refresh-loading.3e7c5fa5.svg";
export { ForwardRef as ReactComponent };